





































































import { Component, Ref, Vue } from 'vue-property-decorator'

import getSearchDefine from './search'
import getTableDefine from './table'
import getModalDefine from './modal'

import { PagerData } from '@/libs/request/request'
import service, { MeritsList } from '@/api/merits/MeritsList'
import genealogyService from '@/api/genealogy/Genealogy'
import genealogyMemberService from '@/api/genealogy/GenealogyMember'
import donationService from '@/api/donation/Donation'

import IForm from '@/libs/formHelper/form/form.vue'
import IModalForm from '@/libs/formHelper/modalForm/modalForm.vue'
import IPagerTable from '@/libs/tableHelper/pagerTable.vue'
import { memberChoose } from '@/components/member'
import { donationChoose } from '@/components/donation'
import dayjs from 'dayjs'

@Component({
  components: {
    IForm,
    IPagerTable,
    IModalForm
  }
})
export default class extends Vue {
  query: any = {
    page: 1,
    pageSize: 10,
    sorts: ['createTime']
  };

  // 选择的村庄
  village: any = {
    villageId: -1,
    villageName: ''
  };

  // 表格数据
  tabledata: PagerData<MeritsList> = {
    total: 0,
    items: []
  };

  loading: boolean = true;

  genealogy: any;

  // 表格列定义
  get tableDefine () {
    return getTableDefine(this)
  }

  get searchDefine () {
    return getSearchDefine(this)
  }

  get modalDefine () {
    return getModalDefine(this)
  }

  @Ref('modal')
  modalRef?: IModalForm<MeritsList>;

  created () {
    this.query.genealogyId = this.$route.query.id
    genealogyService
      .getOneGenealogy(this.query.genealogyId)
      .then((res: any) => {
        this.genealogy = res.result
      })
    this.freshFromServer()
  }

  chooseMember (formValue: any) {
    const back = (res: any) => {
      formValue.memberId = res.id
      formValue.genealogyMember = res
    }
    memberChoose(back, this.query.genealogyId,0)
  }

  clearMember (formValue: any) {
    formValue.memberId = -1
    formValue.genealogyMember.name = ''
  }

  chooseDonation (formValue: any) {
    const back = (res: any) => {
      console.log(res)
      formValue.donationId = res.id
      formValue.donation.name = res.name
    }
    donationChoose(back, this.genealogy.villageId)
  }

  clearDonation (formValue: any) {
    formValue.donationId = -1
    formValue.donation.name = ''
  }

  fetchDataFromServer (
    curPage: number | undefined = undefined,
    pageSize: number | undefined = undefined
  ) {
    if (curPage) {
      this.query.page = curPage
    }
    if (pageSize) {
      this.query.pageSize = pageSize
    }

    let loading = this.$Loading
    loading.start()
    this.loading = true

    if (this.village.villageId > -1) {
      this.query.villageId = this.village.villageId
    } else delete this.query.villageId
    if (!this.query.name) delete this.query.name

    service
      .getPagesOfMeritsList(this.query)
      .then((pagers) => {
        this.tabledata = pagers.result!
      })
      .catch((err) => {
        this.$Message.error(err.message)
      })
      .finally(() => {
        loading.finish()
        this.loading = false
      })
  }

  //  刷新当前页
  freshFromServer (): void {
    this.fetchDataFromServer()
  }

  onSearch () {
    this.fetchDataFromServer(1)
  }

  // 点击创建新的数据
  onNewItem () {
    let data: any = {}
    data.genealogyMember = {
      name: ''
    }
    data.donation = {
      name: ''
    }
    this.modalRef && this.modalRef.openForNew(data)
  }

  // 插入数据
  onInsertItem (dataItem: MeritsList) {
    dataItem.donationTime = dayjs(dataItem.donationTime).format(
      'YYYY-MM-DD HH:mm:ss'
    )
    dataItem.genealogyId = this.query.genealogyId
    return service.addOneMeritsList(dataItem).then(() => {
      this.$Message.success('新增成功')
      this.freshFromServer()
    })
  }

  onViewItem (dataItem: MeritsList) {
    this.modalRef && this.modalRef.openForView(dataItem)
  }

  // 点击编辑数据
  async onEditItem (dataItem: any) {
    let res: any
    if (dataItem.memberId) {
      res = await genealogyMemberService.getOneGenealogyMember(dataItem.memberId)
      console.log(res.result)
      dataItem.genealogyMember = {
        name: res.result ? res.result.name : ''
      }
    } else dataItem.genealogyMember.name = ''

    this.modalRef && this.modalRef.openForModi(dataItem)
  }

  // 更新数据
  onUpdateItem (dataItem: MeritsList) {
    dataItem.donationTime = dayjs(dataItem.donationTime).format('YYYY-MM-DD HH:mm:ss')
    return service.updateOneMeritsList(dataItem).then(() => {
      this.$Message.success('更新成功')
      this.freshFromServer()
    })
  }

  onDelItem (dataItem: MeritsList) {
    return service
      .deleteOneMeritsList(dataItem.id!)
      .then(() => {
        this.$Message.success('删除成功')
        this.freshFromServer()
      })
      .catch((error) => {
        this.$Message.error(error.message)
      })
  }

  backToGenealogyMain () {
    let routerName = 'genealogyManageAll'
    if (this.$route.query.type === 'family') {
        routerName = 'familyManageAll'
    }
    this.$router.push({
      name: routerName
    })
  }
}
